import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDragHandle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 22 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M9 15H7v2h2zM9 21H7v2h2zM9 9H7v2h2zM15 15h-2v2h2zM15 21h-2v2h2zM15 9h-2v2h2z" })
});
export default SvgDragHandle;
